export const ACTION_TYPE = 'actionType';
export const USER_IDS = 'userIds';
export const TEAM_IDS = 'teamIds';
export const TARGET_PROPERTY = 'targetProperty';
export const OVERWRITE_CURRENT_OWNER = 'overwriteCurrentOwner';
export const ROUTING_RULE_DEFINITION = 'routingRuleDefinition';